import React from 'react';

interface MySVGProps {
  width?: string;   // 宽度
  height?: string;  // 高度
  color?: string;   // 颜色
  d: string;       // path 的 d 属性
  style?: React.CSSProperties; // 样式
  onClick?: (e: React.MouseEvent<SVGSVGElement>) => void; // 点击事件
  // 鼠标移入事件
  onMouseEnter?: (e: React.MouseEvent<SVGSVGElement>) => void;
  // 鼠标移出事件
  onMouseLeave?: (e: React.MouseEvent<SVGSVGElement>) => void;
}

const MySVGComponent: React.FC<MySVGProps> = ({ width = 20, height = 20, color, d, style, onClick, onMouseEnter, onMouseLeave }) => {
  return (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <path
        d={d}
        fill={color} // 使用传入的颜色
      />
    </svg>
  );
};
export default MySVGComponent 
